import React, { useEffect, useState } from 'react'
import "./Clock.css"
const Clock = () => {
    const [days, setdays] = useState()
    const [hours, sethours] = useState()
    const [minutes, setminutes] = useState()
    const [seconds, setseconds] = useState()
    let interval;
    const countDown = () => {
        const destination = new Date("Mar 14,2023").getTime()
        interval = setInterval(() => {
            const now = new Date().getTime()
            const diffrent = destination - now;
            // const reset = diffrent - diffrent;
            const days = Math.floor(diffrent / (1000 * 60 * 60 *24))
            const hours  = Math.floor(diffrent  % (1000 * 60 * 60 * 24) / (1000 * 60 * 60 ))
            const minutes = Math.floor( diffrent %(1000 * 60 * 60 ) / (1000 * 60))
            const seconds = Math.floor(diffrent % (1000 * 60 ) / (1000 ))
            if(destination < 0) clearInterval(interval.current)
            else{
                setdays(days)
                sethours(hours)
                setminutes(minutes)
                setseconds(seconds)
            }
        })
    }
    useEffect(() => {
    countDown()
    }, [ ])
  return (
    <div className='clock'>
        <div className="clock_data">
            <div className="da_data">
                <h2>{days}</h2>
                <h4>Days</h4>
            </div>
            <div className="ho_data">
            <h2>{hours}</h2>
                <h4>Hours</h4>
            </div>
            <div className="min_data">
                <h2>{minutes}</h2>
                <h4>Minutes</h4>
            </div>
            <div className="sec_data">
                <h2>{seconds}</h2>
                <h4>Seconds</h4>
            </div>
        </div>
    </div>
  )
}

export default Clock